import React, { useEffect, useState } from 'react';
import { View, Text, ScrollView, StyleSheet, Platform } from 'react-native';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebaseConfig';
import { DEFAULT_PRIVACY } from '../constants/legalDefaults';
import NavigationHeader from '../components/NavigationHeader';
import { ScreenBackground } from '../components/ThemeGradients';

function pickLegalText(remote, fallback) {
  return typeof remote === 'string' && remote.trim().length > 0 ? remote : fallback;
}

export default function PrivacyScreen() {
  const [legalContent, setLegalContent] = useState(null);

  useEffect(() => {
    const unsub = onSnapshot(
      doc(db, 'site_config', 'legal_content'),
      (snap) => { if (snap.exists()) setLegalContent(snap.data()); },
      () => {}
    );
    return () => unsub();
  }, []);

  const privacyText = pickLegalText(legalContent?.privacyPolicy, DEFAULT_PRIVACY);

  return (
    <View style={styles.container}>
      <ScreenBackground />
      <NavigationHeader />
      <ScrollView
        style={styles.scroll}
        contentContainerStyle={styles.contentContainer}
        showsVerticalScrollIndicator={false}
      >
        <View style={styles.card}>
          <Text style={styles.pageTitle}>Privacy Policy</Text>
          <View style={styles.divider} />
          <Text style={styles.body}>{privacyText}</Text>
        </View>
        <View style={{ height: 60 }} />
      </ScrollView>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#000000',
  },
  scroll: {
    flex: 1,
    marginTop: Platform.OS === 'web' ? 110 : 0,
  },
  contentContainer: {
    paddingHorizontal: Platform.OS === 'web' ? 48 : 20,
    paddingTop: Platform.OS === 'web' ? 64 : 32,
    paddingBottom: 60,
    alignItems: 'center',
  },
  card: {
    width: '100%',
    maxWidth: 1080,
    backgroundColor: 'rgba(255,255,255,0.03)',
    borderRadius: 16,
    borderWidth: 1,
    borderColor: 'rgba(255,255,255,0.08)',
    padding: 32,
  },
  pageTitle: {
    color: '#fff',
    fontSize: 22,
    fontWeight: '700',
    marginBottom: 16,
  },
  divider: {
    height: 1,
    backgroundColor: 'rgba(255,255,255,0.08)',
    marginBottom: 20,
  },
  body: {
    color: 'rgba(255,255,255,0.75)',
    fontSize: 13,
    lineHeight: 22,
    ...(Platform.OS === 'web' ? { whiteSpace: 'pre-wrap' } : {}),
  },
});
